import {
    IconA1,
    IconA2,
    IconA3,
    IconA4,
    IconA5,
    IconA6,
    IconA7,
    IconA8,
    IconA9,
    IconA10,
    IconA11,
    IconA12,
    IconB1,
    IconB2,
    IconB3,
    IconB4,
    IconB5,
    IconB6,
    IconB7,
    IconB8,
    IconB9,
    IconB10,
    IconC1,
    IconC2,
    IconC3,
    IconC4,
    IconC5,
    IconC6,
    IconC7,
    IconC8,
    IconC9,
} from './Svg';
import { solarPowerTran } from './textLang';

export const getIconList = (locale: string, tab: 'a' | 'b' | 'c' | 'd') => {
    if (tab === 'a') {
        return [
            {
                name: solarPowerTran[locale].a_name_1,
                icon: IconA1,
            },
            {
                name: solarPowerTran[locale].a_name_2,
                icon: IconA2,
            },
            {
                name: solarPowerTran[locale].a_name_3,
                icon: IconA3,
            },
            {
                name: solarPowerTran[locale].a_name_4,
                icon: IconA4,
            },
            {
                name: solarPowerTran[locale].a_name_5,
                icon: IconA5,
            },
            {
                name: solarPowerTran[locale].a_name_6,
                icon: IconA6,
            },
            {
                name: solarPowerTran[locale].a_name_7,
                icon: IconA7,
            },
            {
                name: solarPowerTran[locale].a_name_8,
                icon: IconA8,
            },
            {
                name: solarPowerTran[locale].a_name_9,
                icon: IconA9,
            },
            {
                name: solarPowerTran[locale].a_name_10,
                icon: IconA10,
            },
            {
                name: solarPowerTran[locale].a_name_11,
                icon: IconA11,
            },
            {
                name: solarPowerTran[locale].a_name_12,
                icon: IconA12,
            },
        ];
    }
    if (tab === 'b') {
        return [
            {
                name: solarPowerTran[locale].b_name_1,
                icon: IconB1,
            },
            {
                name: solarPowerTran[locale].b_name_2,
                icon: IconB2,
            },
            {
                name: solarPowerTran[locale].b_name_3,
                icon: IconB3,
            },
            {
                name: solarPowerTran[locale].b_name_4,
                icon: IconB4,
            },
            {
                name: solarPowerTran[locale].b_name_5,
                icon: IconB5,
            },
            {
                name: solarPowerTran[locale].b_name_6,
                icon: IconB6,
            },
            {
                name: solarPowerTran[locale].b_name_7,
                icon: IconA10,
            },
            {
                name: solarPowerTran[locale].b_name_8,
                icon: IconA11,
            },
            {
                name: solarPowerTran[locale].b_name_9,
                icon: IconA12,
            },
        ];
    }
    if (tab === 'c') {
        return [
            {
                name: solarPowerTran[locale].c_name_1,
                icon: IconB4,
            },
            {
                name: solarPowerTran[locale].c_name_2,
                icon: IconB5,
            },
            {
                name: solarPowerTran[locale].c_name_3,
                icon: IconB6,
            },
            {
                name: solarPowerTran[locale].c_name_4,
                icon: IconA10,
            },
            {
                name: solarPowerTran[locale].c_name_5,
                icon: IconA11,
            },
            {
                name: solarPowerTran[locale].c_name_6,
                icon: IconA12,
            },
        ];
    }
    if (tab === 'd') {
        return [
            {
                name: solarPowerTran[locale].d_name_1,
                icon: IconA10,
            },
            {
                name: solarPowerTran[locale].d_name_2,
                icon: IconA11,
            },
            {
                name: solarPowerTran[locale].d_name_3,
                icon: IconA12,
            },
        ];
    }
    return [];
};
